export const EventType = {
  Default: 'default',
  Wedding: 'wedding',
  Corporate: 'corporate',
  Private: 'private',
  RequestCallback: 'requestCallback',
}
